// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MygJ","content":"styles_content__1Fr5i","tableWrap":"styles_tableWrap__1pqp4"};